document.addEventListener('DOMContentLoaded', function() {
    if (typeof Swiper !== 'undefined') {
        window.thumbnailSwiper = new Swiper('#product-thumbnail-slider', {
            loop: false,
            spaceBetween: 10,
            slidesPerView: 'auto',
            freeMode: true,
            watchSlidesProgress: true,
            slideToClickedSlide: true,
        });

        window.mainSwiper = new Swiper('#product-image-slider', {
            loop: false,
            slidesPerView: 1,
            thumbs: {
                swiper: window.thumbnailSwiper,
            },
        });

        setTimeout(() => {
            const firstThumb = document.querySelector('#product-thumbnail-slider .swiper-slide');
            if (firstThumb) {
                firstThumb.classList.add('swiper-slide-thumb-active');
            }
        }, 100);
    }
});

// Resimleri güncelleme fonksiyonu - dışarıdan çağrılabilir
function updateGalleryForVariation(variationId) {
    if (!variationId) return;
    
    const mainSlider = document.querySelector('#product-image-slider');
    const thumbnailSlider = document.querySelector('#product-thumbnail-slider');
    
    if (!mainSlider || !thumbnailSlider) return;

    // JSON verilerini HTML elemanından okuyoruz
    let variationImageMap = {};
    try {
        const rawMap = mainSlider.getAttribute('data-variation-map');
        if (rawMap) {
            variationImageMap = JSON.parse(rawMap);
        }
    } catch (e) {
        console.error('Varyasyon resim haritası parse edilemedi:', e);
    }
    
    // Bu variant'a ait slide'ları bul
    const targetSlide = mainSlider.querySelector(`.swiper-slide[data-variation-id="${variationId}"]`);
    const targetThumb = thumbnailSlider.querySelector(`.swiper-slide[data-variation-id="${variationId}"]`);
    
    if (targetSlide && targetThumb) {
        // Slide index'lerini bul
        const slides = Array.from(mainSlider.querySelectorAll('.swiper-slide'));
        const thumbs = Array.from(thumbnailSlider.querySelectorAll('.swiper-slide'));
        
        const slideIndex = slides.indexOf(targetSlide);
        const thumbIndex = thumbs.indexOf(targetThumb);
        
        // Swiper'ları güncelle (window nesnesi üzerinden erişerek)
        if (window.mainSwiper && slideIndex >= 0) {
            window.mainSwiper.slideTo(slideIndex);
        }
        if (window.thumbnailSwiper && thumbIndex >= 0) {
            window.thumbnailSwiper.slideTo(thumbIndex);
        }
        
        // Tüm thumbnail'lerden aktif sınıfını kaldır
        thumbs.forEach(thumb => {
            thumb.classList.remove('swiper-slide-thumb-active');
        });
        
        // Seçili thumbnail'e aktif sınıfını ekle
        targetThumb.classList.add('swiper-slide-thumb-active');
        
    } else if (variationImageMap && variationImageMap[variationId]) {
        // Eğer variant'a ait özel slide yoksa, ilk slide'ı güncelle
        const variationImageUrl = variationImageMap[variationId];
        
        const firstSlide = mainSlider.querySelector('.swiper-slide');
        const firstThumb = thumbnailSlider.querySelector('.swiper-slide');
        
        if (firstSlide) {
            const img = firstSlide.querySelector('img');
            if (img) img.src = variationImageUrl;
            firstSlide.setAttribute('data-variation-id', variationId);
        }
        
        if (firstThumb) {
            const img = firstThumb.querySelector('img');
            if (img) img.src = variationImageUrl;
            firstThumb.setAttribute('data-variation-id', variationId);
        }
        
        // Swiper'ları güncelle
        if (window.thumbnailSwiper && window.mainSwiper) {
            window.thumbnailSwiper.update();
            window.mainSwiper.update();
            window.mainSwiper.slideTo(0);
            window.thumbnailSwiper.slideTo(0);
            
            // İlk thumbnail'i aktif yap
            setTimeout(() => {
                const thumbs = thumbnailSlider.querySelectorAll('.swiper-slide');
                thumbs.forEach(thumb => thumb.classList.remove('swiper-slide-thumb-active'));
                if (firstThumb) firstThumb.classList.add('swiper-slide-thumb-active');
            }, 50);
        }
    }
}

// Global olarak erişilebilir yap
window.updateGalleryForVariation = updateGalleryForVariation;